module.exports = __webpack_public_path__ + "static/media/carfixio-2.7902e363.jpg";